<div class="bn-dashboard">
  <header class="bn-dashboard__header">
    <p class="bn-dashboard__date">{{ today | date: 'EEEE, MMMM d' }}</p>
    <h1 class="bn-dashboard__greeting">{{ greeting() }}</h1>
  </header>

  <div class="bn-dashboard__widgets">
    @for (widget of registry.widgets(); track widget.id) {
      @if (!widget.visible || widget.visible()) {
        <section
          class="bn-dashboard__widget"
          [class.bn-dashboard__widget--card]="widget.id !== 'askNaviGo'"
          [attr.data-widget-id]="widget.id"
        >
          <ng-container *ngComponentOutlet="widget.component" />
        </section>
      }
    } @empty {
      <p class="bn-dashboard__empty">
        No dashboard views are registered yet.
      </p>
    }
  </div>
</div>
